<template>
  <bk-page class="bokaOrderPage" :loading="!payStatus || bkLoad">

    <bk-view v-if="payStatus == 'success'" class="view-res" :style="{textAlign: 'center', paddingTop: '20vh'}">
      <bk-title langCode="bokaRenew_text_success">【{{ orderId }}】</bk-title>
      <bk-view>
        <bk-title>payment order number: {{merchantTransactionId}}</bk-title>
      </bk-view>
      <bk-view class="view-tip">
        <bk-title langCode="bokaRenew_text_successTip"></bk-title>
      </bk-view>
    </bk-view>

    <bk-view v-if="payStatus == 'cancel'" class="view-res" :style="{textAlign: 'center', paddingTop: '20vh'}">

      <bk-title langCode="bokaRenew_text_cancel"></bk-title>
      <bk-view>
        <bk-title>No.{{ orderId}}</bk-title>
      </bk-view>

    </bk-view>

  </bk-page>
</template>

<script>

	import {orderReq} from '@/reqService/index';
	import BkButton from '../../components/bk-base/bk-button/bk-button';
	import BkTitle from '../../components/bk-base/bk-title/bk-title';

	const planList = [
		{
			id: '0b512622719245f4a16ec81ae94b63ae',
			name: 'AiMe annual fee(年费)',
			product: 'RENEW',
			price: 2499,
			imgUrl: 'https://static-global.boka.vc/mase/images/Def_Mase_Soft_49.png',
		},
		{
			id: 'c07f763b8d3543298a2448da5535cfd7',
			name: 'MaSe Software(MaSe新购软件)',
			product: 'PURCHASE', // 增购
			price: 499,
			imgUrl: 'https://static-global.boka.vc/mase/images/Def_Mase_Soft_49.png',
		},
		{
			id: '3fd7cb8c32f640688c5f62f7cdbd6b40',
			name: 'MaSe monthly fee(月费)',
			product: 'RENEW',
			price: 49,
			imgUrl: 'https://static-global.boka.vc/mase/images/Def_Mase_Soft_49.png',
		},
		{
			id: 'a2eed57094cb4b6b92647757694cd856',
			name: 'MaSe annual fee(年费)',
			price: 499,
			product: 'RENEW',
			imgUrl: 'https://static-global.boka.vc/mase/images/Def_Mase_Soft_499.png',
		},


		{
			id: 'b65451304afb400ab9e7f514346d56b9',
			name: 'Top up MaSe SMS account with 500 (MaSe短信账户 充值$500)',
			price: 500,
			product: 'SMS',
			checked: true,
		},
		{
			id: '4fee508e1bb440388462f55a00aa22b4',
			name: 'Top up MaSe SMS account with 300 (MaSe短信账户 充值$300)',
			price: 300,
			product: 'SMS',
		},
		{
			id: '28dfdac94f8f402cb6c0fd1eb70e0d8b',
			name: 'Top up MaSe SMS account with 200 (MaSe短信账户 充值$200)',
			price: 200,
			product: 'SMS',
		},
		{
			id: '253476f12a974aa597d91cdaa6987dc3',
			name: 'Top up MaSe SMS account with 100 (MaSe短信账户 充值$100)',
			price: 100,
			product: 'SMS',
		},

		{
			id: '1d742058fd544122898bf0f8dd00bea0',
			name: 'Top up MaSe SMS account with 50 (MaSe短信账户 充值$50)',
			price: 50,
			product: 'SMS',
		},

		{
			id: '19dedbad93524282add9ad1f0a1e0c3e',
			name: 'Top up MaSe SMS account with 20 (MaSe短信账户 充值$20)',
			price: 20,
			product: 'SMS',
		},

		{
			id: '8147ec03c1ba460ab017898658a48be7',
			name: 'Top up MaSe SMS account with 10 (MaSe短信账户 充值$10)',
			price: 10,
			product: 'SMS',
		},


		{
			id: '9ea0416c69d042ae9096a38a42116440',
			name: 'Top up MaSe WhatsApp account with 200 (MaSe WhatsApp账户 充值$200)',
			price: 200,
			product: 'WhatsApp',
			checked: true,
		},

		{
			id: 'dea3d61767a14c46a7e8e98fcf874972',
			name: 'Top up MaSe WhatsApp account with 100 (MaSe WhatsApp账户 充值$100)',
			price: 100,
			product: 'WhatsApp',
		},

		{
			id: 'fa792eeac6ae4760902ef7e3280b2105',
			name: 'Top up MaSe WhatsApp account with 50 (MaSe WhatsApp账户 充值$50)',
			price: 50,
			product: 'WhatsApp',
		},
		{
			id: '2c0fc3792204438fa54f6eb567d74458',
			name: 'Top up MaSe WhatsApp account with 20 (MaSe WhatsApp账户 充值$20)',
			price: 20,
			product: 'WhatsApp',
		},
		{
			id: '5f70dca7825c4f62879fb839760cfdf5',
			name: 'Top up MaSe WhatsApp account with 10 (MaSe WhatsApp账户 充值$10)',
			price: 10,
			product: 'WhatsApp',
		}
	];

	export default {
		name: 'bokaOrder',
		components: {},
		data () {
			bkLog.log('query:', this.$route.query);
			let {custId, compCode, shopId, source, planId, status, orderId, fixedAmount, merchantTransactionId, fixedCurrency} = this.$route.query;

			return {
				custId,
				compCode,
				shopId,
				planId,
				orderId,
				source: source || 'MALL',
				bkLoad: false,

				payStatus: undefined,
				merchantTransactionId,

				planList,
				fixedAmount,
				fixedCurrency,
			};
		},
		created () {

			document.title = this.$bk_getTextWithLangCode('bokaRenew_title');

			if (this.payStatus == 'success' || this.payStatus == 'cancel') {

				return;
			}
			if (this.merchantTransactionId && this.merchantTransactionId != '') {
				this.bkLoad = true;
				this.requestGetPayOrderInfo();
				return;
			}

			let that = this;
			this.payPlan = this.$bk_findObjInList(this.planList, 'id', this.planId);

			bkLog.log('planId:', this.planId);
			bkLog.log('payPlan:', this.payPlan);

			if (this.payPlan && this.payPlan.name) {
				document.title = this.payPlan.name;
			}

			if (this.fixedAmount && this.fixedAmount > 1) {
				this.payPlan.price = this.fixedAmount;
			}

			// if (this.custId == 'BKGJ') {
			// 	this.payPlan.price = 0.01;
			// }

			let token = this.$bk_getAccessToken();

			if (!token || token == '') {
				let that = this;
				window.viewCallback = function () {
					that.createbokaPayOrder();
				};
				return;
			}
			that.createbokaPayOrder();
		},
		methods: {
			async createbokaPayOrder () {

				let {custId, shopId, compCode, mobile, payPlan, planId, source} = this;

				if (!payPlan) {
					this.$bk_message.error(`Renewal plan details missing【${planId}】.`);
					return;
				}
				if (!shopId) {
					this.$bk_message.error(`Renewal store details missing【${shopId}】.`);
					return;
				}

				let parame = {
					custId,
					compId: shopId,
					compCode: compCode,
					source: source || 'MALL',
					product: payPlan.product || 'RENEW', //'RENEW' SMS：短信,RENEW：续费,PURCHASE：新购
					mobile: mobile || '',
					remark: '',
					bkOrderItemsList: [
						{
							itemsId: payPlan.id,
							name: payPlan.name,
							price: payPlan.price,
							quantity: 1
						}
					],
					bkOrderPaymentList: [
						{
							payMethodCode: 'CASH', //CASH，COUPON "couponCode": ""
							amount: payPlan.price,
						}
					]
				};

				let res = await orderReq.requestPostCreateOnlineBokaOrder(this, parame);

				bkLog.log('下单结果：', res);

				this.requestPostCreateOnlinePayOrder(res);
			},

			async requestGetPayOrderInfo () {
				let {merchantTransactionId} = this;

				let parame = {
					paymentOrderId: merchantTransactionId
				};

				let res = await orderReq.requestGetBokaPayOrderInfo(this, parame).catch(() => {}) || {};
				this.bkLoad = false;
				bkLog.log('下单结果：', res);

				// I 初始化 S 支付成功 P 支付中 F 支付失败 C 取消 RP 退款中 RS 退款成功 RF 退款失败


				if (res.tradeStatus == 'F') {
					this.$bk_message.error('Failed to pay, please retry.【支付失败请重试！】');
					this.payStatus = 'cancel';
					return;
				}
				if (res.tradeStatus == 'C') {
					this.$bk_message.error('Cancel, please retry.【支付取消！】');
					this.payStatus = 'cancel';
					return;
				}
				if (res.tradeStatus == 'S') {
					this.payStatus = 'success';
					return;
				}

				setTimeout(function () {
					this.requestGetPayOrderInfo();
				}.bind(this), 1000);
			},

			async requestPostCreateOnlinePayOrder (data) {

				let {custId, shopId, compCode, mobile, payPlan, planId, fixedCurrency} = this;

				let paymentCustomer = {
					'firstName': custId,
					'lastName': compCode,
					'phone': mobile || '',
				};

				let parame = {
					custId: custId,
					compId: shopId,
					compCode: compCode,
					amount: payPlan.price,
					desc: `${custId}-博卡软件续费`,
					paymentGoodsList: [{
						name: payPlan.name,
						price: payPlan.price,
						quantity: 1,
						imgUrl: payPlan.imgUrl,
					}],
					language: 'zh-CN',
					paymentCustomer,
					payResultUrl: 'https://pay.mase.cloud/bokaOrder?orderId=' + data.id + '&status=success',
					payCancelUrl: 'https://pay.mase.cloud/bokaOrder?status=cancel',
					businessType: 'BK',
					businessOrderId: data.id
				};

				if (fixedCurrency && fixedCurrency != '') {
					parame.currency = fixedCurrency;
				}

				console.info('requestPostCreateOnlinePayOrder:', data);

				let res = await orderReq.requestPostCreateOnlinePayOrder(this, parame);

				let mode = 'production';

				if (window.location.href.indexOf('pay-test.mase.cloud') != -1) {
					mode = 'sandbox';
				}

				const conf = {
					mode: mode, //sandbox/production (必填参数)
					lang: parame.language, //  语言，不传默认英语 - de德语 en英语 es西班牙语 fr法语 it意大利语 ru俄语 zh中文 jp日语
					root: '#app', //  PingPong收银台在哪个元素上渲染 须为id (必填)
					manul: false, // 手动模式。 即：支付按钮需要自己渲染，开启后可使用client.actionPayment()方法调用支付
					showPrice: true, // 是否展示价格
					bill: true, // 是否显示bill
					located: true, // 是否显示located(默认为true)
					menu: true, //是否显示支付方式按钮
					base: {
						width: '100%', // 收银台宽度
						height: '800px', // 收银台高度
						backgroundColor: '#fff', // 收银台整体背景色
						// 顶部价格及币种
						priceBgColor: '#fff', // 顶部价格区域背景色
						priceFontColor: '#1fa0e8', // 顶部价格字体颜色
						priceFontSize: '32px', // 顶部价格字体大小
						priceMB: '10px', // 顶部价格区域距底部间距

						// 引导标题: “How would you like to pay”
						showHeaderLabel: true, // 是否显示引导标题
						headerMB: '24px', // 引导标题距底部间距
						headerSize: '20px', // 引导标题字体大小
						headerColor: 'rgba(0, 0, 0, 0.85)', // 引导标题字体颜色
						headerfontWeight: 700, // 引导标题加粗

						// 支付方式
						payMethodsWidth: '240px', // 支付方式按钮宽度
						payMethodsHeight: '48px', // 支付方式按钮高度
						payMethodsColor: 'rgba(0, 0, 0, 0.85)', // 支付方式按钮字体颜色
						payMethodsActiveColor: '#1fa0e8', // 支付方式按钮点击后字体颜色
						payMethodsFontsize: '14px', // 支付方式按钮字体大小
						payMethodsActiveBorderColor: '#1fa0e8', // 支付方式按钮点击后边框颜色
						payMethodsActiveBorderShadow: '0 2px 8px 0 rgb(31 160 232 / 20%)', // 支付方式按钮点击后阴影
						showIcons: true, // 是否显示卡图标
						showHeaderAmount: true, // 是否显示头部支付金额
						// 表单相关
						formItemMargin: '16px', // 表单距底部间距
						formItemBorderColor: 'rgba(0, 0, 0, 0.08)', // 表单边框颜色
						formItemFocusColor: '#1fa0e8', // 表单聚焦时提示文案和边框颜色

						// 支付按钮
						btnSize: '100%', // 按钮宽度百分比或者px
						btnColor: '#fff', // 按钮字体颜色
						btnFontSize: '14px', // 按钮字体大小
						btnMarginTop: '10px', // button 距顶部距离
						btnMarginBottom: '24px', // button 距底部距离
						btnBackgroundColor: '#1fa0e8', // 按钮背景色
						btnBorderRadius: '8px', // 按钮圆角
						btnBorderColor: '#1fa0e8', // 可单独配置btn边框颜色覆盖btnBorder中设置的颜色
					}
				};


				// eslint-disable-next-line new-cap
				let client = new ppPay(conf);

				// 在这里传入 从接口中获取到的token
				// let token ='EU:Dt10Deb05qeI0HFWg0DU1NPcLE-dxCDiU40wyKBxHw1w1RDULBtXXtI2dsgSX8L7';
				//使用此方法将会创建收银台
				client.createPayment(res.token);

				// manul 模式 使用此方法将不会出现支付按钮，支付时机将会取决于持卡人的调用
				// client.actionPayment(callback)

			},
		}
	};
</script>

<style lang="less">

.bokaRenewPage {
  padding: 20px;
  .view-res {
    text-align: center;
  }
}


#pp-sdk-iframe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

</style>